import { useContext, useEffect } from "react";
import Logo from "../../assets/images/survey/logo.svg";
import CampaignContext from "../../contexts/CampaignContext";
import UserContext from "../../contexts/UserContext";
import restService from "../../restService";

const campaignID = "62834ed429b3cbe224437a3e"; //prod
// const campaignID = "62716fbcba13726d1a3f9d07"; //sandbox

const Nav = () => {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  // console.log(user);

  const toggleNav = () => {
    const sidebar = document.getElementById("mobileSideBar");
    sidebar.classList.toggle("-translate-x-full");
    document.body.classList.toggle("overflow-hidden");
  };

  const showActionMenu = (id) => {
    document.getElementById(id).classList.toggle("hidden");
  };

  const handleLogout = () => {
    sessionStorage.clear();
    restService.Auth.redirectToAuth();
  };

  // useEffect(() => {
  //   console.log(campaign);
  // }, [campaign]);
  return (
    <nav className="w-full z-[999] flex justify-center shadow-md bg-white">
      <div className="flex z-50  items-center justify-between w-full px-8 py-6 ">
        <div className="flex gap-3 items-center">
          {/* <div className="hidden md:block mr-3">
            <a>
              <img
                height="35px"
                width="35px"
                src="https://upload.wikimedia.org/wikipedia/en/thumb/e/e8/Shell_logo.svg/1200px-Shell_logo.svg.png"
                alt="brand"
              />
            </a>
          </div> */}
          {campaign.id === campaignID ? (
            <div>
              <img src={Logo} alt="" width={"35px"} height={"35px"} />
            </div>
          ) : (
            <div className="w-7 h-7 bg-[#00C74C] hidden lg:block rounded"></div>
          )}
          <div className="hidden lg:block">
            <p className="m-0 p-0">{campaign.name}</p>
          </div>

          <div className="lg:hidden">
            <button
              onClick={() => toggleNav()}
              className="text-white p-1.5 hover:bg-[#FFFDFB] bg-[#FFFDFB] focus:bg-[#FFFDFB] rounded-2xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="black"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </button>
          </div>

          {/*<div className="md:hidden">*/}
          {/*  <div id="hamburger">*/}
          {/*    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
          {/*      <path d="M25 22.5H7M25 9.5H7H25ZM25 16H7H25Z" stroke="#24211D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>*/}
          {/*    </svg>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        <div className="flex items-center">
          {/* <div className="px-4">
            <div>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.8944 15.1406C11.6734 15.5867 11.3321 15.9621 10.9091 16.2245C10.4861 16.487 9.99825 16.626 9.50044 16.626C9.00264 16.626 8.51474 16.487 8.09175 16.2245C7.66876 15.9621 7.3275 15.5867 7.10645 15.1406"
                  stroke="#848484"
                  strokeMiterlimit="10"
                  strokeMiterlimit="square"
                />
                <path
                  d="M18.4062 15.7344C18.4062 14.2203 17.3969 12.4688 15.4375 11.5781V6.82812C15.4329 5.25482 14.8058 3.74728 13.6933 2.63478C12.5808 1.52229 11.0733 0.895246 9.5 0.890625V0.890625C7.9267 0.895246 6.41916 1.52229 5.30666 2.63478C4.19416 3.74728 3.56712 5.25482 3.5625 6.82812V11.5781C1.60313 12.4688 0.59375 14.2203 0.59375 15.7344"
                  stroke="#848484"
                  strokeMiterlimit="10"
                />
                <path
                  d="M18.4062 15.7344C18.4062 16.9812 14.4148 18.1094 9.5 18.1094C4.58523 18.1094 0.59375 16.9812 0.59375 15.7344C0.59375 14.4875 4.58523 13.3594 9.5 13.3594C14.4148 13.3594 18.4062 14.4875 18.4062 15.7344Z"
                  stroke="#848484"
                  strokeMiterlimit="10"
                  strokeMiterlimit="square"
                />
              </svg>
            </div>
          </div> */}
          <div>
            <div className="flex justify-between items-center">
              <div className="md:px-4 relative inline-block">
                <div
                  type="button"
                  id="logout-button"
                  aria-expanded="true"
                  aria-haspopup="true"
                  className="w-9 flex items-center justify-center h-9 capitalize rounded-full bg-[#fc450b] text-white text-sm cursor-pointer "
                  onClick={() => showActionMenu("logout")}
                >
                  {Object.keys(user).length
                    ? user.username.split(" ")[0][0] +
                      user.username.split(" ")[1][0]
                    : ""}
                </div>

                <button
                  className="border hover:bg-[#F4F4F4] text-sm border-gray-400 whitespace-nowrap	rounded py-1.5 px-3 absolute hidden  origin-top-left bg-white md:left-0 left-[-20px]  mt-2"
                  // className=" ring-1 ring-black ring-opacity-5 focus:outline-none left-0 z-10 shadow-lg w-50 bg-white rounded-lg"
                  aria-orientation="horizontal"
                  aria-labelledby="logout-button"
                  tabIndex="-1"
                  id="logout"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
              <div className="hidden md:block leading-5">
                <p className="m-0 p-0">{user.username}</p>
                {/* <p className="m-0 p-0 text-sm text-gray-400">Admin</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
